import { Highlight, themes } from "prism-react-renderer";

interface Props {
  code: string;
  language?: string;
}

// Read-only syntax-highlighted code block. Used inside lesson prose for fenced
// ```python (and other) blocks. In Plan 03 the runnable editor will live in
// the dedicated IDE area; this is for in-prose, illustrative code only.
export function CodeBlock({ code, language = "python" }: Props): JSX.Element {
  return (
    <Highlight code={code.trim()} language={language} theme={themes.nightOwl}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={`${className} overflow-x-auto rounded-card border border-border-subtle p-4 text-sm`}
          style={style}
        >
          {tokens.map((line, i) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { key: _k, ...lineProps } = getLineProps({ line });
            return (
              <div key={i} {...lineProps}>
                {line.map((token, j) => {
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  const { key: _tk, ...tokenProps } = getTokenProps({ token });
                  return <span key={j} {...tokenProps} />;
                })}
              </div>
            );
          })}
        </pre>
      )}
    </Highlight>
  );
}
